import request from '@/utils/request'

// 获取图片验证码
export function getCaptcha () {
  return request.get('/common/captcha')
}

// 下载本地文件
export function downloadLocalFile (params) {
  return request.get('/resource/local/download', {
    params,
    download: true
  })
}

// 根据密码登录
export function loginByPassword (data) {
  return request.post('/system/login', data)
}

// 登出
export function logout (data) {
  return request.post('/system/logout', data)
}

// 修改密码
export function updatePwd (data) {
  return request.post('/system/updatePwd', data)
}

// 获取已登录的用户信息
export function getUserInfo () {
  return request.get('/system/getUserInfo', {
    autoLogin: false
  })
}

// 获取打印机模板列表
export function getTemplateListApi (data) {
  return request.post('/printer/template/getList', data)
}

// 获取所有字典
export function getDictList() {
  return request.post('/system/dict/list');
}